/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters
} from 'vuex';
import bulletsPoint from '../tab-details-bullets-point/index';
export default {
  name: 'course-tab-details',
  components: {
    'bullets-point': bulletsPoint
  },
  props: ['tabID'],
  data() {
    return {
      name: 'Other',
      content: '',
      course: '',
      courseTabDetais: {},
      submitted: false,
      id: '',
      deleteTABID: '',
      tabActiveStatus: '',
      activeStatuTabID: '',
      tabActive: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'getcourseDetailstabByIDState'
    ]),
    GetTabDeTailsByIDFun() {
      this.$store.dispatch('getCourseTabDetailsByID', {
        id: this.tabID
      }).then((res) => {
        this.courseTabDetais = this.$store.getters.getcourseDetailstabByIDState.data.data
        this.name = this.$store.getters.getcourseDetailstabByIDState.data.data.name
        this.content = this.$store.getters.getcourseDetailstabByIDState.data.data.content
        this.tabActiveStatus = this.courseTabDetais.is_active
        console.log(this.courseTabDetais.is_active, "Tab Details By ID")
      }).catch((err) => {})
    }
  },
  mounted() {
    this.GetTabDeTailsByIDFun
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {}).catch((err) => {})
    },
    validateUpdateCourseTabSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            content: this.content
          }
          this.$store.dispatch('updateCourseTabDetailsByID', {
              data: {
                data: data,
                id: this.tabID
              }
            }).then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                bus.$emit('hideEditTabDetailsPopup', false)
                toast.success(res.data.msg);
              }
            })
            .catch((err) => {})
          return
        }
      });
    },
    deleteTabListFun() {
      $('body').addClass('removeOverlay');
      $('#removeTabFun').modal()
      this.deleteTABID = this.tabID
    },
    removeTabConfirmation() {
      let data = {
        id: this.deleteTABID
      }
      this.$store.dispatch('RemoveCourseTabByID', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'Course Tab removed successfully');
            this.getCourseDetailsAgain();
            bus.$emit('hideEditTabDetailsPopup', false)
          }
        })
        .catch((err) => {})
    },
    courseTabStatusAct(id) {
      this.activeStatuTabID = id;
      console.log(this.activeStatuTabID, 'assignment ID')
      let data = {
        id: this.activeStatuTabID
      }
      this.$store.dispatch('getCourseTabDetailsByID', data)
        .then((res) => {
          if (res.data.code == '2000') {
            // console.log(this.$store.getters.singleAssignmentState.id,'assignment data')
            this.tabActive = this.$store.getters.getcourseDetailstabByIDState.data.data.is_active
            if (this.tabActive === true) {
              // debugger
              this.is_active = false
            }
            if (this.tabActive === false) {
              // debugger
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateCourseTabDetailsByID', {
              data: {
                data: data,
                id: this.activeStatuTabID
              }
            }).then((res) => {
              if (res.status == '200') {
                this.tabActiveStatus = res.data.data.is_active
                console.log(res.data.data.is_active)
                toast.success("Course Tab Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    }
  }
}